var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQnaWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6382 38.2764L39.2643 37.9633L39.2643 37.9633L38.6382 38.2764ZM36.8304 34.6607L36.2043 34.9738L36.8304 34.6607ZM8.3 24C8.3 32.6709 15.3291 39.7 24 39.7V38.3C16.1023 38.3 9.7 31.8977 9.7 24H8.3ZM24 8.3C15.3291 8.3 8.3 15.3291 8.3 24H9.7C9.7 16.1023 16.1023 9.7 24 9.7V8.3ZM39.7 24C39.7 15.3291 32.6709 8.3 24 8.3V9.7C31.8977 9.7 38.3 16.1023 38.3 24H39.7ZM37.628 31.8005C38.9464 29.5019 39.7 26.8379 39.7 24H38.3C38.3 26.587 37.6136 29.0117 36.4136 31.104L37.628 31.8005ZM36.2043 34.9738L38.0121 38.5894L39.2643 37.9633L37.4565 34.3477L36.2043 34.9738ZM38.0121 38.5894C37.9456 38.4565 38.0423 38.3 38.191 38.3V39.7C39.083 39.7 39.6632 38.7612 39.2643 37.9633L38.0121 38.5894ZM38.191 38.3H24V39.7H38.191V38.3ZM36.4136 31.104C35.7556 32.251 35.5706 33.7064 36.2043 34.9738L37.4565 34.3477C37.073 33.5807 37.1544 32.6263 37.628 31.8005L36.4136 31.104Z",
    fill: "#BE69C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.0198C20.25 17.8257 22.3823 16.101 24.8039 16.5807C26.2183 16.8562 27.3648 17.9379 27.6648 19.2646C28.0505 20.9892 27.0862 22.5506 25.5861 23.2139C24.6217 23.6425 24.0003 24.5304 24.0003 25.5305V27.75",
    stroke: "#BE69C2",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.75C24.5178 32.75 24.9375 32.3303 24.9375 31.8125C24.9375 31.2947 24.5178 30.875 24 30.875C23.4822 30.875 23.0625 31.2947 23.0625 31.8125C23.0625 32.3303 23.4822 32.75 24 32.75Z",
    fill: "#BE69C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQnaWrite);
export default __webpack_public_path__ + "static/media/qna_write.2eff7e3f473b8ce55e637134113ff3e6.svg";
export { ForwardRef as ReactComponent };